import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { DISCOUNTS_ENABLED } from '../content/features';
import site from '../content/site';
import './Footer.css';

export default function Footer() {
  const { user } = useAuth();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <img src="/assets/logo.png" alt="Volcyy" className="footer__logo" />
          <p className="footer__tagline">{site.TAGLINE}</p>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/joinvolcyy/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="Volcyy on Instagram"
            >
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" stroke="currentColor" strokeWidth="1.7"/>
                <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.7"/>
                <circle cx="17.6" cy="6.4" r="1.25" fill="currentColor"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@joinvolcyy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="Volcyy on TikTok"
            >
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M13.2 2.6h2.6c.18 1.5.86 2.79 1.94 3.62.79.6 1.77.95 2.86 1v2.66c-1.77-.05-3.35-.6-4.66-1.55v6.35c0 3.4-2.63 6.12-5.9 6.12S4.1 18.08 4.1 14.68c0-3.28 2.45-5.95 5.56-6.11v2.75c-1.6.16-2.86 1.56-2.86 3.26 0 1.8 1.42 3.27 3.17 3.27s3.18-1.47 3.18-3.27V2.6z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
        <nav className="footer__links" aria-label="Footer navigation">
          <div className="footer__col">
            <h4>Explore</h4>
            <Link to="/">Explore</Link>
            {DISCOUNTS_ENABLED && <Link to="/benefits">Benefits</Link>}
            <Link to="/contact">Contact</Link>
            <Link to="/business">For Businesses</Link>
          </div>
          {user && <div className="footer__col">
            <h4>Account</h4>
            <Link to="/profile">Profile</Link>
          </div>}
          <div className="footer__col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <button type="button" className="footer__cookie-settings" onClick={() => window.dispatchEvent(new Event("volcyy:cookie-settings"))}>Cookie Settings</button>
          </div>
        </nav>
      </div>
      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Volcyy. All rights reserved.</p>
        <a href="mailto:contact@volcyy.com">contact@volcyy.com</a>
      </div>
    </footer>
  );
}
